// Grouping for the navbar "Credit Solutions" menu. Titles and descriptions mirror
// the solutions data in solutions-v2.component.ts; solutions-menu.spec.ts fails
// if they drift.

export interface SolutionMenuItem {
  id: string;
  title: string;
  description: string;
}

export interface SolutionMenuGroup {
  title: string;
  items: readonly SolutionMenuItem[];
}

export const SOLUTION_MENU: readonly SolutionMenuGroup[] = [
  {
    title: 'Real estate',
    items: [
      { id: 'residential-mortgage', title: 'Residential Real Estate Mortgage', description: 'Premium mortgage solutions for primary, secondary, and investment properties.' },
      { id: 'commercial-real-estate', title: 'Commercial Real Estate Mortgage', description: 'Financing for acquisition, refinancing, or development of commercial properties.' },
    ],
  },
  {
    title: 'Business',
    items: [
      { id: 'commercial-business', title: 'Commercial Business Solutions', description: 'Working capital and growth financing for commercial enterprises.' },
      { id: 'acquisition-loans', title: 'Acquisition Loans for Financial Advisors', description: 'Finance the acquisition, sale, or recapitalization of advisory practices.' },
    ],
  },
  {
    title: 'Asset-backed',
    items: [
      { id: 'sbloc', title: 'Securities Backed Line of Credit', description: 'Liquidity without selling assets using investment portfolios as collateral.' },
      { id: 'ibloc', title: 'Insurance Backed Line of Credit', description: 'Leverage permanent life insurance cash value for flexible liquidity.' },
      { id: 'luxury-assets', title: 'Luxury Asset Collateralization', description: 'Unlock capital from fine art, yachts, aircraft, and high-end collectibles.' },
    ],
  },
];
